const articleGroups = {
  "部落客實測體驗分享": [
    {
      title:
        "【生活日常｜口腔護理】出門在外不管正式或休閒的場合，都超需要乾淨的門面！全方位的漱口水推薦～慷碩生醫 舒冷P113+口腔護理系列",
      link: "https://daida0515.pixnet.net/blog/posts/15339533145",
      image: "https://pimg.1px.tw/daida0515/1684218319-1954155544-g.png",
    },
    {
      title:
        "口腔保健推薦~【慷碩生醫】舒冷系列(清新牙膏+清新漱口水+高效防護噴劑)，添加P113+獨家專利活性肽，給你全方位的口腔護理！",
      link: "https://s107262000.pixnet.net/blog/posts/10356142874",
      image: "https://s3.1px.tw/blog/common/avatar/blog_cover_light.jpg",
    },
    {
      title:
        "*口腔護理* 慷碩生醫 舒冷P113 + 口腔護理系列   大人小孩好用推薦 無酒精漱口水 培養健康的好人緣、好情緒",
      link: "https://hellomelody.pixnet.net/blog/posts/7121926143",
      image: "https://pimg.1px.tw/hellomelody/1683978317-4092569519-g.jpg",
    },
  ],
  "慷碩生醫林口中心參訪體驗": [
    {
      title: "慷碩生醫林口中心體驗活動、舒冷P113+系列",
      link: "https://p88628.pixnet.net/blog/posts/2036426053",
      image: "https://pimg.1px.tw/p88628/1685263507-2065746435-g.jpg",
    },
    {
      title:
        "慷碩生醫P113 + 體驗活動｜舒冷P113 + 系列是口腔護理推薦｜慷碩生醫林口中心",
      link: "https://teresasky0622.pixnet.net/blog/posts/15339651325",
      image: "https://pimg.1px.tw/teresasky0622/1685260534-1316279456-g.jpg",
    },
    {
      title: "慷碩生醫林口中心體驗活動半日遊－推薦舒冷P113+口腔護理系列",
      link: "https://prettysnow.pixnet.net/blog/posts/2036422486",
      image: "https://pimg.1px.tw/prettysnow/1685195230-3636343817-g.jpg",
    },
  ],
  "PIXNET網友好評推薦": [
    {
      title:
        "【口腔保健】慷碩生醫-舒冷P113+口腔護理系列，強化口腔清潔護理、舒緩牙齦敏感的不適感、口氣清新/預防蛀牙/預防口臭，超推薦",
      link: "https://drugs.pixnet.net/blog/posts/3050536500",
      image: "https://pimg.1px.tw/drugs/1685197462-499416094-g.jpg",
    },
    {
      title:
        "[ 保養 ]口腔微生態護理很重要！前往慷碩生醫林口中心一日體驗！推薦舒冷P113+口腔護理系列，實在有厲害到～",
      link: "https://nataliepink.pixnet.net/blog/posts/5070653159",
      image: "https://pimg.1px.tw/nataliepink/1684855067-1710753504-g.jpg",
    },
    {
      title:
        "[團購] 5/20~6/10 親子出國必帶的智慧辨菌口腔逆轉神器!牙醫推薦的舒冷P113+活性肽 (#1)",
      link: "https://youwin721.pixnet.net/blog/posts/5071188741",
      image: "https://pimg.1px.tw/youwin721/1716123994-497402806-g.png",
    },
  ],
};

export default articleGroups;
